import { useMemo } from 'react';
import { Moment } from 'moment-timezone';
import { TimeZoneFormat, TimeZoneMode } from '@shared/utils/constants';
import { fromISOTimezone, toISOTimezone } from '@shared/utils/timezones';

const useDisplayDateFromWallTime = (
	date: Moment | null,
	timeZoneFormat: TimeZoneFormat,
	timezone?: string,
) => {
	return useMemo(() => {
		if (date == null) {
			return null;
		}

		const iso = toISOTimezone(
			date,
			timeZoneFormat,
			timezone,
			TimeZoneMode.WallTime,
		);

		if (iso == null) {
			return null;
		}

		return fromISOTimezone(
			iso,
			timeZoneFormat,
			timezone,
			TimeZoneMode.Instant,
		);
	}, [date, timeZoneFormat, timezone]);
};

export default useDisplayDateFromWallTime;
